/**
 * 文件策略接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DocumentTypeService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 文件策略接口
  /**
   * 查询文件策略所有信息
   * @param param
   * @returns {Observable<any>}
   */
  getDocumentTypeList(param) {
    const url = this.filefix + 'fileConfig/queryPageVoList';
    return this.http.Post(url, param);
  }

  /**
   * 查看文件策略信息
   * @param param
   * @returns {Observable<any>}
   */
  getDocumentType(param) {
    const url = this.filefix + 'fileConfig/queryVoById';
    return this.http.Post(url, param);
  }

  /**
   * 更新文件策略信息
   * @param param
   * @returns {Observable<any>}
   */
  updateDocumentType(param) {
    const url = this.filefix + 'fileConfig/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 删除文件策略单个信息
   * @param param
   * @returns {Observable<any>}
   */
  deleteDocumentType(param) {
    const url = this.filefix + 'fileConfig/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 增加文件策略单个信息
   * @param param
   * @returns {Observable<any>}
   */
  saveDocumentType(param) {
    const url = this.filefix + 'fileConfig/saveByVo';
    return this.http.Post(url, param);
  }

  //#endregion


}
